module.exports = __webpack_public_path__ + "img/EvanSai.61834adc.png";